// extracted by mini-css-extract-plugin
module.exports = {"main-component":"addTaskButton_main-component__2iyjS"};